$('.buyRecipeGo').click(function () {
    swal({
        text: "Espere un momento",
        icon: imageURL_2,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: https + "/buyRecipe",
        method: "POST",
        data: {
            id: this.id,
            action: "buyRecipe"
        },
        success: function (data) {
            if ($.trim(data) == "complet") {
                location.href = https + "/payu/pay";
            }else {
                swal({
                    text: "Ha ocurrido un error" + data,
                    icon: imageURL_2,
                    button: "OK!",
                });
            }
        }
    });
});
